import styled from "styled-components/native";
import { spacing, wpdColor } from "../theme";
import AmountIndicator from "./amountIndicator";

export const AmountIndicatorSecondary = styled(AmountIndicator)`
  background-color: ${wpdColor.primary};
  color: ${wpdColor.primaryContrastLighter};
  margin-left: ${spacing.small};
  margin-right: 0;
`;
